export const REPORT_PARAMS = {
    REPORT_PARAM_DATE_RANGE: "REPORT_PARAM_DATE_RANGE",
    REPORT_PARAM_REGIONS: "REPORT_PARAM_REGIONS",
    REPORT_PARAM_DATE_TYPE: "REPORT_PARAM_DATE_TYPE",
    REPORT_PARAM_CLIENT_PROFILE_IDS: "REPORT_PARAM_CLIENT_PROFILE_IDS",
    REPORT_PARAM_SERVICE_LEVELS: "REPORT_PARAM_SERVICE_LEVELS",
};